import React, { Component } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as FuseActions from 'store/actions'
import * as Actions from 'auth/store/actions'
import connect from 'react-redux/es/connect/connect'

class Logout extends Component {
  componentDidMount () {
    this.props.logoutUser()
  }

  render () {
    return <Redirect to='/' />
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    logoutUser: Actions.logoutUser,
    showMessage: FuseActions.showMessage
  }, dispatch)
}

function mapStateToProps ({ auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout))
